import React, { useContext } from "react"
import { Context } from "../components/store/UserProvider"
import CourseMainContent from "../components/CourseMainContent/CourseMainContent"
import CourseSidebar from "../components/CourseSidebar/CourseSidebar"

//done

import { useStaticQuery, graphql } from "gatsby"
import LogInTest from "../components/log-in/LogInTest"
import useGetComments from "../components/custom_hooks/use-getcomments"

const CourseName = ({ pageContext: { id, strapi_id }, data }) => {
  let lesson_id = id
  const ctx = useContext(Context)
  const { commentData } = useGetComments(strapi_id)

  return (
    <div>
      {/* <LogInTest /> */}
      <CourseSidebar
        course={data.strapiCourse}
        lesson_id={lesson_id}
        watchedVids={ctx.watchedVids}
      />
      <CourseMainContent
        commentData={commentData}
        videos={data.strapiCourse.lessons}
        lesson_id={lesson_id}
        info={data.allStrapiCourseVideo.nodes[0].discussion}
        strapi_id={strapi_id}
        watchedVids={ctx.watchedVids}
      />
    </div>
  )
}

export const query = graphql`
  query getSingleCourse($handle: String) {
    strapiCourse(handle: { eq: $handle }) {
      handle
      title
      lessons {
        strapi_id
        id
        title
        video
        watched
        free
        description
        additional_resources {
          url
          name
        }
        thumbnail
        playtime
      }
    }
    allStrapiCourseVideo {
      nodes {
        discussion {
          title
          comment
          post_button
        }
      }
    }
  }
`

export default CourseName
